import useInFlightKeys from '../../../hooks/useInFlightKeys';

/**
 * Per-row edit wiring shared by every status-edit surface (the cycle roster
 * and the profile Promotion tab). The mutation hooks spread this into their
 * return value, so a screen only needs:
 *
 *   editStatus(rowKey, status)  — run the edit with the row marked in flight
 *   isRowPending(rowKey)        — disable only that row's control
 *
 * Tracked per row, NOT via the mutation's isPending/variables: useMutation
 * state follows only the latest mutate call, so gating on it would re-enable
 * a row the moment another row starts its own edit.
 */
export const useRowStatusEditor = (mutation, rowKeyField) => {
  const inFlightRows = useInFlightKeys();

  return {
    editStatus: (rowKey, status) =>
      inFlightRows.track(rowKey, () =>
        mutation.mutateAsync({ [rowKeyField]: rowKey, status })),
    isRowPending: inFlightRows.has,
  };
};
